import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import {
  faChartLine,
  faClock,
  faChartBar,
  faCartPlus,
  faTable,
  faCheck,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import * as toastr from 'toastr'
import { MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import * as moment from 'moment';
import * as _ from 'lodash';

import { ConsultRequest } from '@shared/utils/consult-request';
import { UserTypes, FlagPrevisao } from '@shared/enums';
import { User, LinhaVenda } from '@shared/models';
import { FiltersOfConsult } from '@shared/utils/filters-of-consult';

import { ScreenLoadingService } from '@core/services/screen-loading.service';

import { ClientesService } from '../../services/clientes.service';
import { RetornoGetPrevisaoVendasItem, RetornoGetPeriodoPrevisaoVendas, ParametrosSalvarOuAtualizarPrevisaoVendas, RetornoGetPrevisaoVendas } from '@core/services/vendas.interface';

import {VerificaPrevisaoCompletaService} from './services/verifica-previsao-completa.service'
import {VendasService} from '@core/services/vendas.service'
import {JuntarPrevisaoSalvaComNovaPrevisaoService} from './services/juntar-previsao-salva-com-nova-previsao.service'

import { MostruarioIdealModalComponent } from '../../modals/mostruario-ideal-modal/mostruario-ideal-modal.component';
import { CarteiraFuturaModalComponent } from '../../modals/carteira-futura-modal/carteira-futura-modal.component';
import {HistoricSalesModalComponent} from '../../modals/historic-sales-modal/historic-sales-modal.component'
import { HistoricModalTypes } from '../../modals/historic-sales-modal/historic-sales-modal.models';

import { Filters, Periodo } from './previsao-vendas.models';
import {GetPrevisaoVendasParamsService} from './services/get-previsao-vendas-params.service'
import { SettingService } from '@core/services/setting.service';
import { ComboComponent } from '@shared/components/combo/combo.component';
import { PrevisaoVendasService } from '@core/services/previsaoVendas.service';

const initialFilters: Filters = {
  setor: null,
  uf: null,
  cidade: null,
  bairro: null,
  statusPrevisao: null,
  razaoSocialOuCnpj: null,
  clientesProspecao: true
}

@Component({
  selector: 'app-previsao-vendas',
  templateUrl: './previsao-vendas.component.html',
  styleUrls: ['./previsao-vendas.component.scss'],
})

export class PrevisaoVendasComponent implements OnInit {
  @ViewChild(CarteiraFuturaModalComponent, {static: true}) caterteiraFuturaModal: CarteiraFuturaModalComponent;
  @ViewChild(MostruarioIdealModalComponent, {static: true}) mostruarioIdealModalComponent: MostruarioIdealModalComponent;
  @ViewChild(HistoricSalesModalComponent, {static: true}) historicoFaturamentoModalComponent: HistoricSalesModalComponent;

  UserTypes = UserTypes
  FlagPrevisao = FlagPrevisao;

  userLogado: User;

  faChartLine = faChartLine;
  faClock = faClock;
  faChartBar = faChartBar;
  faTable = faTable;
  faCartPlus = faCartPlus;
  faCheck = faCheck;
  faTimes = faTimes;

  idSetorComC:number;

  linhasRequest = new ConsultRequest<LinhaVenda[]>({
    showLoadAtStart: true
  })
  periodoPrevisaoRequest = new ConsultRequest<RetornoGetPeriodoPrevisaoVendas>({
    showLoadAtStart: true
  })
  consultaRequest = new ConsultRequest<RetornoGetPrevisaoVendas>()

  totalPecasRequest = new ConsultRequest<number>({showLoadAtStart: true})
  totalClientesSemPrevisaoRequest = new ConsultRequest<number>({showLoadAtStart: true})
  salvarPrevisoesRequest = new ConsultRequest();

  totalConsulta = 0;

  filtersOfConsult = new FiltersOfConsult<Filters>(initialFilters);

  filtersOfConsultActive = new FiltersOfConsult<Filters>(initialFilters);

  paginationGetPrevisaoVendas = {
    page: 1,
    limit: 5
  }

  daysToClose: string;
  backendVersion: string;

  currentYear = moment().year()

  previsoes: ParametrosSalvarOuAtualizarPrevisaoVendas[] = [];
  previsoesSalvas: ParametrosSalvarOuAtualizarPrevisaoVendas[] = [];

  displayedColumns = ['uf', 'cidade', 'bairro', 'cnpj', 'razaoSocial', 'tipoComercio']
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  private debouncedGetSetor =  _.debounce((setorCdfzs?:string)=>this.getIdSetorComc(setorCdfzs), 650, {
    'leading': false,
    'trailing': true
  })

  periodo: Periodo = {
    ano: null,
    mesFinal: null,
    mesInicial: null
  }

  constructor(
    private clientesService: ClientesService,
    private vendasService: VendasService,
    private router: Router,
    private screenLoadingService: ScreenLoadingService,
    private settingService: SettingService,
    private previsaoVendasService: PrevisaoVendasService,
  ) {
  }

  ngOnInit() {
    const user = localStorage.getItem("user_logado");
    this.userLogado = JSON.parse(user);

    if(this.isUserSac){
      this.periodo.ano = this.currentYear;
    }else{
      const {idSetor, setor} = this.userLogado;
      const {filters} = this.filtersOfConsult

      filters.setor = {
        id: idSetor,
        codigo: setor,
      }
    }

    this.getInitialData()

    this.dataSource.sort = this.sort;

    this.getDaysToClose()
  }

  get temPrevisaoParaSalvar(){
    return this.previsoes.length > 0;
  }

  handleConsultar(){
    if(this.temPrevisaoParaSalvar){
      toastr.error('Algumas previsões ainda não foram salvas, salve-as antes de consultar')
      return;
    }
    this.filtersOfConsultActive.setAll(this.filtersOfConsult.filters)

    this.getPrevisaoVendas(1);
  }

  handlePageOrSizeChange(pageEvent: PageEvent){
    const sizeChange = pageEvent.pageSize !== this.paginationGetPrevisaoVendas.limit;

    if(sizeChange){
      this.paginationGetPrevisaoVendas.limit = pageEvent.pageSize

      if(!this.consultaRequest.hasLoadedSomeTime){
        return;
      }

      this.getPrevisaoVendas(1)
      return;
    }

    this.getPrevisaoVendas(pageEvent.pageIndex+1)
  }

  verifyIfPrevisaoEstaCompleta(cliente: RetornoGetPrevisaoVendasItem){
    if(cliente.idTipoComercio === 31){ //cliente prospecao
      return true;
    }

    return this.isPrevisaoCompleta(cliente);
  }

  resetFilters(filtersOfConsult: FiltersOfConsult<Filters>){
    filtersOfConsult.reset([
      'bairro',
      'cidade',
      'statusPrevisao',
      'uf',
      'razaoSocialOuCnpj'
    ])
  }

  handleHistoricClick({razaoSocial, idCliente, cnpj}: RetornoGetPrevisaoVendasItem, type: HistoricModalTypes){
    this.historicoFaturamentoModalComponent.open({
      ano: this.ultimoAnoPrevisao,
      cliente: {
        razaoSocial,
        cnpj,
        idCliente
      },
      linhas: this.linhasRequest.data,
      type
    })
  }

  handleCarteiraFuturaClick(
    {
      idCliente,
      cnpj,
      razaoSocial,
      setorCdfzs,
      possuiCarteiraFutura
    }: RetornoGetPrevisaoVendasItem
  ){
    if(!possuiCarteiraFutura){
      toastr.error('O Cliente não possui carteira futura')
      return;
    }

    this.caterteiraFuturaModal.openModal({
      id: idCliente,
      cnpj,
      razaoSocial,
      setorCdfzs,
    })
  }

  handleMostruarioIdealClick(
    {
      idCliente,
      cnpj,
      razaoSocial,
      setorCdfzs
    }: RetornoGetPrevisaoVendasItem
  ){
    this.mostruarioIdealModalComponent.openModal({
      cliente:{
        id: idCliente,
        cnpj,
        razaoSocial,
        setorCdfzs,
      },
      linhas: this.linhasRequest.data
    })
  }

  handleCheckBoxChange(){
    const {filters} =  this.filtersOfConsult;
    filters.clientesProspecao = true;
  }

  handleVoltar(){
    if(this.temPrevisaoParaSalvar){
      toastr.error('Algumas previsões ainda não foram salvas, salve-as antes de voltar a página anterior')
      return;
    }

    this.router.navigate(["/clientes/home/"]);
  }

  get initialInfoIsLoading(){
    return this.linhasRequest.isLoading || this.periodoPrevisaoRequest.isLoading
  }

  getPrevisaoDoMesLinha(retornoGetPrevisaoVendasItem: RetornoGetPrevisaoVendasItem, linha: LinhaVenda, anoMes: number){
    const quantidadePorMesLinha =  retornoGetPrevisaoVendasItem.previsaoVenda.find(
      item => item.linhas == linha.linhas && item.anoMes === anoMes
    )

    return quantidadePorMesLinha ? quantidadePorMesLinha.quantidade : null;
  }

  handleQuantidadePrevisaoChange(event: any, retornoGetPrevisaoVendasItem: RetornoGetPrevisaoVendasItem, linha: LinhaVenda, anoMes: number){
    const update: ParametrosSalvarOuAtualizarPrevisaoVendas = {
      idCliente: retornoGetPrevisaoVendasItem.idCliente,
      idLinhaProduto: this.getIdLinhaProduto(linha.linhas),
      noAnoMes: anoMes,
      quantidade: event.target.value
    }

    const previsaoIndex =  this.previsoes.findIndex(
      item => (
        item.idCliente === update.idCliente &&
        item.noAnoMes === update.noAnoMes &&
        item.idLinhaProduto === update.idLinhaProduto
      )
    )

    if(previsaoIndex !== -1){
      this.previsoes[previsaoIndex] = update
      return;
    }

    this.previsoes.push(update)
  }

  handleSalvar(){
    if(this.previsoes.length === 0){
      toastr.error('Nenhuma alteração encontrada')
      return;
    }

    this.screenLoadingService.showLoading();

    this.salvarPrevisoesRequest.get(
      this.vendasService.salvarOuAtualizarPrevisaoVendas(
        this.previsoes
      ),
      () => {
        this.previsoesSalvas = [
          ...this.previsoes,
        ]
        this.previsoes = []
        toastr.success('Previsões Atualizadas Com sucesso')
        this.getTotalClientesSemPrevisao()
        this.getTotalLancamentos()
      },
      () => {
        toastr.error('Ocorreu um erro ao atualizar as Previsões')
      }
    ).add(() => this.screenLoadingService.hideLoading())

  }

  get showPeriodo(){


    console.log("Aqui")

    if(!this.periodoPrevisaoRequest.data){
      return true;
    }

    return (
      this.periodoPrevisaoRequest.data.anoMesDisponiveisPrevisao &&
      this.periodoPrevisaoRequest.data.anoMesDisponiveisPrevisao.length > 0
      ) || this.periodoPrevisaoRequest.isLoading
  }

  get totalPecasLancadas(){
    if(typeof this.totalPecasRequest.data !== "number"){
      return "";
    }

    return this.totalPecasRequest.data.toString()
  }

  get isUserSac(){
    return this.userLogado.perfil === UserTypes.SAC;
  }

  //metodos privados

  private getIdSetorComc(setorCdfzs?:string){
    const userLogado = this.userLogado;

    this.clientesService.getIdSetor(setorCdfzs  ? setorCdfzs : userLogado.setor)
    .subscribe(
      idSetorComC => {
        if(idSetorComC != 0){
         this.idSetorComC = idSetorComC

         if(setorCdfzs){
          this.filtersOfConsult.filters.setor = {
            codigo: setorCdfzs,
            id: idSetorComC
          }
         }else{
          this.getTotalClientesSemPrevisao()
         }

        }else{
          toastr.error('Setor não encontrado')
        }
      },
      error => {
        toastr.error('Ocorreu um erro inesperado ao carregar os dados iniciais')
      }
    )
  }

  private getTotalLancamentos(){
    const anoMesDisponiveisPrevisao = this.periodoPrevisaoRequest.data.anoMesDisponiveisPrevisao;
    const anoMesInicio = anoMesDisponiveisPrevisao[0]
    const anoMesFinal = anoMesDisponiveisPrevisao[anoMesDisponiveisPrevisao.length-1];

    this.totalPecasRequest.get(
      this.vendasService.getTotalPrevisaoLancamentos({
        anoMesInicio,
        anoMesFinal,
        codigoSetor: this.userLogado.setor
      }),
      ()=>{},
      ()=>{
        toastr.error('Ocorreu um erro inesperado ao carregar os dados iniciais')
      }
    )
  }

  private getTotalClientesSemPrevisao(){
    const anoMesDisponiveisPrevisao = this.periodoPrevisaoRequest.data.anoMesDisponiveisPrevisao;
    const anoMesInicio = anoMesDisponiveisPrevisao[0];
    const anoMesFinal = anoMesDisponiveisPrevisao[anoMesDisponiveisPrevisao.length-1];

    this.totalClientesSemPrevisaoRequest.get(
      this.vendasService.getTotalClientesSemPrevisao({
        anoMesInicio,
        anoMesFinal,
        codigoSetor: this.idSetorComC
      })
    )
  }

  private getInitialData(){
    this.linhasRequest.get(
      this.vendasService.getLinhas(),
      () => {
        this.periodoPrevisaoRequest.get(
          this.vendasService.getPeriodoPrevisaoVendas(),
          () => {
            if(this.userLogado.perfil === UserTypes.VENDEDOR){
              this.getIdSetorComc()
              this.getTotalLancamentos()
            }

            this.preencherColunasPrevisaoVenda(this.periodoPrevisaoRequest.data.anoMesDisponiveisPrevisao)

          },() =>{
            toastr.error('Ocorreu um erro inesperado ao carregar os dados iniciais')
          }
        )
      },
      () => {
        toastr.error('Ocorreu um erro inesperado ao carregar os dados iniciais')
      }
    )
  }

  private getAnoMesByYearAndMonth(ano: number, mes: number){
    return Number(moment(new Date(ano, mes)).format('YYYYMM'))
  }

  private getPrevisaoVendas(page: number){
    const filters = this.filtersOfConsultActive.filters;

    let anoMesInicial: number = null;
    let anoMesFinal: number = null;

    if(this.isUserSac){
      const {ano, mesInicial, mesFinal} = this.periodo;

      if(!filters.setor){
        toastr.error('Campo Setor Obrigatório')
        return;
      }

      if(!mesInicial){
        toastr.error('Campo "Do mês" Obrigatório')
        return;
      }

      if(!mesFinal){
        toastr.error('Campo "Até o mês" Obrigatório')
        return;
      }

      if(mesInicial.id > mesFinal.id){
        toastr.error('Campo "Do mês" precisa ser menor que campo "Até o mês"')
        return;
      }

      anoMesInicial = this.getAnoMesByYearAndMonth(ano, mesInicial.id)
      anoMesFinal = this.getAnoMesByYearAndMonth(ano, mesFinal.id)
    }else{
      if(!filters.setor || !this.periodoPrevisaoRequest.hasLoadedSomeTime){
        toastr.error('Alguns dados ainda estão sendo carregados, tente novamente mais tarde')
        return;
      }

      const lsPrevisaoVenda = this.periodoPrevisaoRequest.data.anoMesDisponiveisPrevisao;
      anoMesInicial = lsPrevisaoVenda[0]
      anoMesFinal = lsPrevisaoVenda[lsPrevisaoVenda.length -1]
    }


    this.paginationGetPrevisaoVendas.page = page;
    this.dataSource.data = []
    this.previsoes = []

    const {limit} = this.paginationGetPrevisaoVendas;

    const getPrevisaoVendasParamsService = new GetPrevisaoVendasParamsService();
    const params = getPrevisaoVendasParamsService.execute(filters, {
      anoMesInicial,
      anoMesFinal,
      limit,
      page,
      idSetorComC: this.idSetorComC
    })

    this.consultaRequest.get(
      this.vendasService.getPrevisaoVendas(params),
      ()=> {
        const {items, total} = this.consultaRequest.data;
        this.dataSource.data = items
        this.totalConsulta = total
      },
      () => {
        toastr.error('Ocorreu um erro ao carregar as previsões')
      }
    )
  }

  get ultimoAnoPrevisao(){
    const periodoPrevisaoRequestData = this.periodoPrevisaoRequest.data;

    if(!periodoPrevisaoRequestData){
      return undefined;
    }

    const anoMesDisponiveisPrevisao = periodoPrevisaoRequestData.anoMesDisponiveisPrevisao;

    if(!anoMesDisponiveisPrevisao){
      return undefined;
    }

    if(anoMesDisponiveisPrevisao.length === 0){
      return moment().year();
    }

    const lastAnoMes = anoMesDisponiveisPrevisao[anoMesDisponiveisPrevisao.length-1];

    const lastYear = Number(lastAnoMes.toString().substring(0,4))

    return lastYear
  }


  onSetorChange(event){
    if(!event.target.value){
      this.filtersOfConsult.filters.setor = null
    }else{
      this.debouncedGetSetor(event.target.value)
    }
  }

  blockAllButPositiveNumbers(event){
    if (
      (event.keyCode < 48 || event.keyCode > 57) &&
      (event.keyCode < 96 || event.keyCode > 105) &&
      event.keyCode != 8 &&
      event.keyCode != 13 &&
      event.keyCode != 46 &&
      event.keyCode != 37 &&
      event.keyCode != 39
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }

  private preencherColunasPrevisaoVenda(periodoAnoMes: number[]){
    const displayedColumns = [
      ...this.displayedColumns
    ]

    if(!this.isUserSac && periodoAnoMes.length > 0){
      displayedColumns.push("statusPrevisao")
      periodoAnoMes.forEach(anoMes => displayedColumns.push(anoMes.toString()))
    }

    if(this.userLogado.perfil === UserTypes.SAC){
      displayedColumns.push('restricaoSerasa')
      displayedColumns.push('linhaDia')
      displayedColumns.push('linhaNoite')
    }

    displayedColumns.push('consultas')

    this.displayedColumns = displayedColumns;
  }

  private getIdLinhaProduto(linhas: string){
    return linhas == "1, 3, 7, 8" ? 3 : 2
  }

  private isPrevisaoCompleta(cliente: RetornoGetPrevisaoVendasItem){
    const juntarPrevisaoSalvaComNovaPrevisaoService = new JuntarPrevisaoSalvaComNovaPrevisaoService();
    const previsaoVendaPorCliente = juntarPrevisaoSalvaComNovaPrevisaoService.execute(cliente, this.previsoes, this.previsoesSalvas)

    const anoMesDisponiveisPrevisao = this.periodoPrevisaoRequest.data.anoMesDisponiveisPrevisao;
    const linhasVendas = this.linhasRequest.data;

    const verificaPrevisaoCompletaService = new VerificaPrevisaoCompletaService(anoMesDisponiveisPrevisao, linhasVendas)

    const previsaoCompleta = verificaPrevisaoCompletaService.execute(previsaoVendaPorCliente)

    return previsaoCompleta;
  }

  getDaysToClose(){

      //this.vendasService.getDaysToClose()
      this.previsaoVendasService.getDaysToClose()
      .subscribe(
        data => {
         this.daysToClose = data._body.toString();
         console.log('recebeu o valor', data._body.toString());
         console.log("textoEncontrado",this.daysToClose);
        },
        error => {
          console.log('error', error)
        }
      )



  }
}
